import { MonitorWizzardPaths } from 'enums/monitor-wizzard-paths';
import { QuestionnaireType } from 'enums/questionnaire-type';

import { CountryList } from 'enums/country';

import QuickActionUser from './QuickActionUser';

import { Analytics } from 'utils/Analytics';
import { AnalyticsEventAction, AnalyticsEventCategory } from 'enums/analytics-types';

const UPGRADE_CHIP_TEXT = 'Upgrade';

const config = ({
  consultant,
  isRecoveryEnabled,
  isCreditImprovementEnabled,
  isRanddEnabled,
  isGrantsEnabled,
  hasMonitoringAccess,
  openQuestionnaireAlpha,
  openUpsellModal,
  openWizzard,
  country,
  openModal,
}) => [
  {
    items: [
      {
        button: {
          children: 'Search unsecured loans',
          onClick: () =>
            openQuestionnaireAlpha({ type: QuestionnaireType.introducerWorkingCapital }),
          tooltip:
            'Quickly match with unsecured lending - great when you’re looking for £1k-£350k.',
          category: QuestionnaireType.introducerWorkingCapital,
          display: true,
        },
      },
      {
        button: {
          children: 'Fund commercial property',
          onClick: () => openQuestionnaireAlpha({ type: QuestionnaireType.introducerProperty }),
          tooltip: 'Find specialist property lenders for property and development projects.',
          category: QuestionnaireType.introducerProperty,
          display: country !== CountryList.SOUTH_AFRICA,
        },
      },
      {
        button: {
          children: 'Recovery Loan Scheme',
          onClick: () =>
            openQuestionnaireAlpha({ type: QuestionnaireType.introducerRecoveryLoanScheme }),
          tooltip: 'Start a funding search for lenders offering government backed loans.',
          category: QuestionnaireType.introducerRecoveryLoanScheme,
          display: country !== CountryList.SOUTH_AFRICA,
        },
      },
      {
        button: {
          children: 'All funding products',
          onClick: () =>
            openQuestionnaireAlpha({ type: QuestionnaireType.introducerAllFundingProducts }),
          tooltip: 'Start a search to match your clients needs with suitable lenders.',
          category: QuestionnaireType.introducerAllFundingProducts,
          display: country !== CountryList.SOUTH_AFRICA,
        },
      },
      {
        button: {
          children: 'Apply for an innovation grant',
          chip: isGrantsEnabled ? false : UPGRADE_CHIP_TEXT,
          onClick: () =>
            isGrantsEnabled
              ? openQuestionnaireAlpha({ type: QuestionnaireType.introducerGrants })
              : openUpsellModal(),
          tooltip: 'Help disruptive businesses accelerate innovative projects.',
          category: QuestionnaireType.introducerGrants,
          display: country !== CountryList.SOUTH_AFRICA,
        },
      },
    ],
    title: 'Raise Capital',
    display: true,
  },
  {
    items: [
      {
        button: {
          children: 'Recover bad debt',
          chip: isRecoveryEnabled ? false : UPGRADE_CHIP_TEXT,
          onClick: () =>
            isRecoveryEnabled
              ? openQuestionnaireAlpha({ type: QuestionnaireType.introducerRecovery })
              : openUpsellModal(),
          tooltip: 'No win no fee service to recover late payments and bad debts.',
          category: QuestionnaireType.introducerRecovery,
          display: country !== CountryList.SOUTH_AFRICA,
        },
      },
      {
        button: {
          children: 'Apply for R&D Tax claim',
          chip: isRanddEnabled ? false : UPGRADE_CHIP_TEXT,
          onClick: () =>
            isRanddEnabled
              ? openQuestionnaireAlpha({ type: QuestionnaireType.introducerRdTaxClaim })
              : openUpsellModal(),
          tooltip:
            "Reclaim up to 33% of your client's research and development costs as a corporation tax refund so they can reinvest the funds back into their business.",
          category: QuestionnaireType.introducerRdTaxClaim,
          display: country !== CountryList.SOUTH_AFRICA,
        },
      },
    ],
    title: 'Recover and Protect',
    display: country !== CountryList.SOUTH_AFRICA,
  },
  {
    items: [
      {
        button: {
          children: 'Add a new client',
          onClick: () => {
            Analytics.track(AnalyticsEventCategory.monitor, AnalyticsEventAction.addClientManual);
            openWizzard(MonitorWizzardPaths.createClient);
          },
          tooltip: 'Connect a client to monitor and start getting insights.',
          category: MonitorWizzardPaths.createClient,
          display: true,
        },
      },
      {
        button: {
          children: 'Refer & Invite client',
          onClick: () => {
            Analytics.track(AnalyticsEventCategory.navbarLaunch, AnalyticsEventAction.inviteClient);
            openModal({}, 'ReferInviteModal');
          },
          tooltip: 'Invite a client to access tools and funding',
          category: MonitorWizzardPaths.importClient,
          display: true,
        },
      },
      {
        button: {
          children: 'Import & analyse clients',
          chip: hasMonitoringAccess ? false : UPGRADE_CHIP_TEXT,
          onClick: () =>
            hasMonitoringAccess
              ? openWizzard(MonitorWizzardPaths.importClient, true)
              : openUpsellModal(),
          tooltip: 'Import and analyse your client portfolio to identify funding opportunities.',
          category: MonitorWizzardPaths.importClient,
          display: true,
        },
      },
      {
        button: {
          children: 'Download a capital report',
          onClick: () => {
            openModal({}, 'GetCapitalReportModal');
          },
          tooltip: "Keep ahead of the game and stay in the loop on your client's credit history.",
          category: MonitorWizzardPaths.emailReport,
          display: true,
        },
      },
    ],
    title: 'Portfolio',
    display: true,
  },
  {
    items: [
      consultant &&
        consultant.has('email') && {
          children: (
            <QuickActionUser
              email={consultant.get('email')}
              name={consultant.get('name')}
              phoneNumber={consultant.get('phoneNumber')}
            />
          ),
        },
    ],
    title: null,
    display: true,
  },
];

export default config;
